module.exports = __webpack_public_path__ + "static/media/dem_for_wor.82109221.png";